/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterForAssessmentRunReport extends models.ScheduleExecutionParameterBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterForAssessmentRunReport");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterForAssessmentRunReport.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterForAssessmentRunReport>): ScheduleExecutionParameterForAssessmentRunReport {
        let obj = Object.assign(new ScheduleExecutionParameterForAssessmentRunReport(), model);
        ScheduleExecutionParameterForAssessmentRunReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterForAssessmentRunReport>): ScheduleExecutionParameterForAssessmentRunReport {
        if (!model) return null;
        return ScheduleExecutionParameterForAssessmentRunReport.newInstance(<ScheduleExecutionParameterForAssessmentRunReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterForAssessmentRunReport) {
        if (!obj) return;

        models.ScheduleExecutionParameterForAssessmentRunReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterForAssessmentRunReport): boolean {
        if (models.ScheduleExecutionParameterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterForAssessmentRunReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Identity of the Framework
     */
    framework_id: string;

    /**
     * Report type for assessment run
     */
    report_type: models.WellArchitectedFrameworkAssessmentRunReportType;

    filters: models.QueryOperator;

}
